"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var Chart_1 = __importDefault(require("../Chart"));
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var ReactDOMServer = __importStar(require("react-dom/server"));
var style_1 = require("../../../../style");
var layout_1 = require("../../../layout");
var Text_1 = __importDefault(require("../../../Text"));
var design_system_colors_1 = require("../../../../style/theme/design-system-colors");
var utils_2 = require("../utils");
var styles = {
    legendIcon: react_1.css({
        height: style_1.pxToRem(8),
        width: style_1.pxToRem(8),
        borderRadius: '50%',
    }),
    legendLabel: react_1.css({
        fontSize: style_1.pxToRem(14),
        fontWeight: 400,
        marginLeft: style_1.pxToRem(8),
    }),
    gaugeCentreContainer: react_1.css({
        fontSize: style_1.pxToRem(14),
        fontWeight: 600,
        color: design_system_colors_1.DesignSystemColor.Gray.DEFAULT,
    }),
    gaugeCentreTitle: react_1.css({
        marginBottom: style_1.pxToRem(5),
        fontSize: style_1.pxToRem(14),
        fontWeight: 400,
        color: design_system_colors_1.DesignSystemColor.Gray.DEFAULT,
    }),
    gaugeTotalValue: react_1.css({
        fontSize: style_1.pxToRem(24),
        fontWeight: 600,
        color: design_system_colors_1.DesignSystemColor.Gray.DARK_4,
    }),
};
var legendItemFormatter = function (color, label) {
    return ReactDOMServer.renderToString(react_1.jsx(layout_1.Flex, { flow: 'row', alignItems: "center" },
        react_1.jsx("span", { css: react_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          ", ";\n          background-color: ", ";\n        "], ["\n          ", ";\n          background-color: ", ";\n        "])), styles.legendIcon, color) }),
        react_1.jsx(Text_1.default, { css: styles.legendLabel }, label)));
};
var gaugeCentreFormatter = function (gaugeCentreTitle, gaugeTotalValue) {
    return ReactDOMServer.renderToString(react_1.jsx(layout_1.Flex, { css: styles.gaugeCentreContainer, flow: "column", alignItems: "center" },
        react_1.jsx(Text_1.default, { css: styles.gaugeCentreTitle }, gaugeCentreTitle),
        react_1.jsx(Text_1.default, { css: styles.gaugeTotalValue }, gaugeTotalValue)));
};
var ActivityGuage = function (_a) {
    var data = _a.data, size = _a.size, _b = _a.gaugeCentreTitle, gaugeCentreTitle = _b === void 0 ? '' : _b, _c = _a.gaugeTotalValue, gaugeTotalValue = _c === void 0 ? '' : _c, _d = _a.legendAlignment, legendAlignment = _d === void 0 ? constants_1.LEGEND_ALIGNMENT.vertical : _d, props = __rest(_a, ["data", "size", "gaugeCentreTitle", "gaugeTotalValue", "legendAlignment"]);
    var options = react_2.useMemo(function () {
        return utils_1.getOptions(utils_1.mapDataWithGaugeDetails(data), size, gaugeCentreTitle, gaugeTotalValue, legendAlignment, utils_2.ChartTooltipFormatterFn, legendItemFormatter, gaugeCentreFormatter);
    }, [data, size, gaugeCentreTitle, gaugeTotalValue, legendAlignment]);
    return react_1.jsx(Chart_1.default, __assign({ options: options }, props));
};
ActivityGuage.SIZES = constants_1.SIZES;
ActivityGuage.LEGEND_ALIGNMENT = constants_1.LEGEND_ALIGNMENT;
exports.default = ActivityGuage;
var templateObject_1;
